import { T } from 'gt-react';
import { PLAIN_TEXT_UNSUPPORTED_FORMAT } from './use-xlsx-parser';

export function XlsxParseErrorText({ error }: { error: string }) {
  if (error === PLAIN_TEXT_UNSUPPORTED_FORMAT) {
    return (
      <T context="error when a price-change case .txt preview has no recognizable delimiter">
        Unsupported file format.
      </T>
    );
  }
  return error;
}
